import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

class SparkLine extends Component {
  constructor(props){
    super(props);
    // this.state = {
    //   chart: 'hidden',
    //   spinner: true
    // }
  }

  componentDidMount(){
    // am4core.options.queue = true;
    am4core.options.deferredDelay = 0;
    const data = this.props.data;
    const titleTxt = this.props.title;
    let chart = null;
    this.createSparkLine(chart, titleTxt, data);
  }

  componentWillUnmount(){
  
    if(this.chart){
      this.chart.dispose();
    }
  }

  createSparkLine = (chart, titleTxt, dataSet) => {
    am4core.options.minPolylineStep = 5;
    am4core.useTheme(am4themes_animated);

    chart = am4core.create(this.sparkLineChart, am4charts.XYChart);
    // chart.events.on('ready', ()=>{this.setState({chart:'visible',spinner:false})})
    chart.data = dataSet;
    chart.padding(0,0,0,0);
  
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.disabled = true;
    dateAxis.renderer.labels.template.disabled = true;
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0.7;
    dateAxis.cursorTooltipEnabled = false; 
  
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.cursorTooltipEnabled = false;
  
    let series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = "date";
    series.dataFields.valueY = "value";
    series.strokeWidth = 2;

    series.stroke = am4core.color("#6E37FA")

    let title = chart.titles.create();
    title.text=titleTxt;
    title.fontSize=10;
    title.align='left';
  
    this.chart = chart;

  }
  
  render(){
    return (
      <div>
        {/* {this.state.spinner ? <SpinnerBox /> : undefined} */}
        {/* <div id="spark-line" ref={ref=>(this.sparkLineChart=ref)} style={{ width: this.props.width, height: this.props.height, visibility:this.state.chart }}></div> */}
        <div id="spark-line" ref={ref=>(this.sparkLineChart=ref)} style={{ width: this.props.width, height: this.props.height}}></div>
      </div>
    )
  }
}

export default SparkLine;